import "./DesignTool.0.css";

/* eslint-disable no-param-reassign */

import { designToolMixin } from "../../../../lib/helpers";
import WButton from "../../../../lib/builtin/components/Button";
import { getCondContainerBranchMenu } from './meta';
const __script_base__ = {
  name: 'CondDesignTool',
  mixins: [designToolMixin],
  components: {
    WButton
  },
  computed: {
    showMulti() {
      var _this$comp$props;
      return ((_this$comp$props = this.comp.props) === null || _this$comp$props === void 0 ? void 0 : _this$comp$props.showMulti) || false;
    },
    branchName() {
      const instance = this.getCompInstance();
      if (!instance) return '[选择分支]';
      const {
        forceBranchIndex,
        branches
      } = instance;
      const branch = branches[forceBranchIndex];
      return branch ? `[${forceBranchIndex + 1}] ${branch.name}` : '兜底分支';
    }
  },
  methods: {
    switchDisplay() {
      this.updateCompProp('showMulti', !this.showMulti);
    },
    addBranch() {
      var _this$comp$props2;
      this.updateCompProp('branches', [...(((_this$comp$props2 = this.comp.props) === null || _this$comp$props2 === void 0 ? void 0 : _this$comp$props2.branches) || []), {
        expr: '1 + 1 === 2',
        id: ~~(Math.random() * 1e6),
        name: ''
      }]);
    },
    showBranchMenu(ev) {
      const {
        target
      } = ev;
      const {
        left: clientX,
        top: clientY
      } = target.getBoundingClientRect();
      const branchMenu = getCondContainerBranchMenu(this.getCompInstance());
      this.designer.openContextMenu({
        clientX,
        clientY
      }, [{
        title: '选择分支',
        items: branchMenu
      }]);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "uc-condDesignTool"
  }, [_c("div", {
    staticClass: "uc-condDesignTool-btnGroup"
  }, [_c("WButton", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.switchDisplay
    }
  }, [_vm._v("\n      " + _vm._s(_vm.showMulti ? "显示单条" : "显示全部") + "\n    ")]), _vm._v(" "), !_vm.showMulti ? _c("WButton", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.showBranchMenu
    }
  }, [_c("i", {
    staticClass: "fa fa-code-fork"
  }), _vm._v(" " + _vm._s(_vm.branchName) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.showMulti ? _c("WButton", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.addBranch
    }
  }, [_c("i", {
    staticClass: "fa fa-plus"
  }), _vm._v(" 添加条件分支\n    ")]) : _vm._e()], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/ConditionalContainer/DesignTool.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);